import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { AndroidAppVersionInterceptor } from './services/android-app-version.interceptor';
import { HttpTimeoutInterceptor } from './services/http-timeout.interceptor';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TimezoneInterceptor } from '@core/interceptors/timezone.interceptor';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { NotificationService } from './services/notification.service';
import { MatDialogModule } from '@angular/material/dialog';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21+: zoneless is the default. This app still loads zone.js (angular.json
    // polyfills) and mutates plain component fields in HTTP/SSE callbacks, so we must
    // opt back into NgZone CD. Angular 22 also defaults components to OnPush; existing
    // components were migrated to ChangeDetectionStrategy.Eager so Zone ticks re-check
    // them without a click.
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    // MatDialog is provided by its module, not root. The root-level service that
    // uses it (ConfirmationService) would otherwise fail with NullInjectorError on
    // the first confirm. Toasts no longer go through MatSnackBar — see ToastService.
    importProvidersFrom(MatDialogModule),
    // Chart.js v4 registers nothing by default, so every BaseChartDirective threw
    // '"category" is not a registered scale' and rendered no chart. PrimeNG's p-chart
    // used to do this registration itself; ng2-charts makes it explicit.
    provideCharts(withDefaultRegisterables()),
    // MatDatepickerModule needs a DateAdapter but doesn't provide one itself (that used
    // to be MatNativeDateModule's job). 8 of the 10 components using mat-datepicker
    // never supplied it locally, so opening any of them threw NG0201: No provider found
    // for DateAdapter — first hit at /employee (attendance-records-modal). Providing it
    // once at root fixes all of them; the two components with their own
    // provideNativeDateAdapter() are unaffected (a closer provider just shadows this one).
    provideNativeDateAdapter(),
    NotificationService,
    /**
     * Auth Interceptor
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    /**
     * Timezone Interceptor
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimezoneInterceptor,
      multi: true,
    },
    /**
     * Global Error Handler
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AndroidAppVersionInterceptor,
      multi: true,
    },
    /**
     * Request Timeout Interceptor
     *
     * Registered last so its timeout wraps the fully-decorated request.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimeoutInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
  ],
};
